import React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

import { getPath } from '../steps';

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiSelect-select:focus': {
      backgroundColor: 'white',
    },

    '& .MuiInputBase-root': {
      fontSize: '1.25rem',
    },
  },
}));

type StepSelectProps = {
  steps: string[],
  value: number,
}

const StepSelect = ({ steps, value }: StepSelectProps) => {
  const classes = useStyles();
  const history = useHistory();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // @ts-ignore
    history.push(getPath(steps, event.target.value));
  }

  return (
    <TextField
      className={classes.root}
      name="steps"
      onChange={handleChange}
      select
      value={value}
    >
      {steps.map((step, index) => (
        <MenuItem key={step + index} value={index}>
          {`${index + 1}. ${steps[index]}`}
        </MenuItem>
      ))}
    </TextField>
  );
}

export default StepSelect;
